export const convertDay = (day: string) => {
	if (day === 'monday') {
		return 'Senin';
	} else if (day === 'tuesday') {
		return 'Selasa';
	} else if (day === 'wednesday') {
		return 'Rabu';
	} else if (day === 'thursday') {
		return 'Kamis';
	} else if (day === 'friday') {
		return 'Jumat';
	} else if (day === 'saturday') {
		return 'Sabtu';
	} else if (day === 'sunday') {
		return 'Minggu';
	}
};
